/**
 * Local / internal trials: ignore Gemini Live opt-out env vars so `npm start` is not blocked by
 * REACT_APP_CHARTMIND_*_DISABLED or STT_UI_DISABLED left over in .env.
 *
 * - `NODE_ENV === 'development'` (Create React App `npm start`) → ungated.
 * - `REACT_APP_CHARTMIND_GEMINI_LIVE_DEV_UNGATED=true` → same in any build (e.g. staging bundle).
 *
 * Production builds still respect DISABLED flags unless DEV_UNGATED is set.
 */

export function isChartMindGeminiLiveUngatedForTrials() {
  if (typeof process === 'undefined') return false;
  if (process.env.NODE_ENV === 'development') return true;
  return process.env.REACT_APP_CHARTMIND_GEMINI_LIVE_DEV_UNGATED === 'true';
}
